import { render, staticRenderFns } from "./AMisRenderer.vue?vue&type=template&id=db6c2f62&scoped=true"
import script from "./AMisRenderer.vue?vue&type=script&lang=js"
export * from "./AMisRenderer.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "db6c2f62",
  null
  
)

export default component.exports